import type {
    IOorkV1ProcedureCustomControlData,
    IVisusFields,
} from '@common/interfaces/ophthalmology/OorkAndOcrk/oorkV1ProcedureCustomControlData';
import type { ValidationErrors } from '@frontend/utils/index';
import { OorkV1ProcedureVisusFieldSetRow } from './OorkV1ProcedureVisusFieldSetRow';

interface IOorkV1ProcedureVisusFieldSetWrapperProps {
    customControlData: IVisusFields;
    errors?: ValidationErrors;
    handleChangeCustomControl?: <T = IOorkV1ProcedureCustomControlData>(values: Partial<T>) => Promise<void>;
    isReadOnly: boolean;
    validateOneCustomControl?: (value: keyof IOorkV1ProcedureCustomControlData) => Promise<void>;
}

const visusFields = [
    { field: 'visus_zonder_correctie', label: 'Visus zonder correctie', required: true },
    { field: 'visus_eigen_correctie', label: 'Visus met eigen correctie', required: false },
    { field: 'visus_optimale_correctie', label: 'Visus met optimale correctie', required: true },
];

export function OorkV1ProcedureVisusFieldSetWrapper(props: IOorkV1ProcedureVisusFieldSetWrapperProps) {
    return (
        <>
            {visusFields.map((visusfield, index) => {
                return (
                    <OorkV1ProcedureVisusFieldSetRow
                        errors={props.isReadOnly ? undefined : props.errors}
                        field={visusfield.field}
                        handleChangeCustomControl={props.handleChangeCustomControl}
                        isReadOnly={props.isReadOnly}
                        isRequired={visusfield.required}
                        key={index}
                        label={visusfield.label}
                        validateOneCustomControl={props.validateOneCustomControl}
                        value_od={props.customControlData[`${visusfield.field}_od` as keyof IVisusFields]}
                        value_ods={props.customControlData[`${visusfield.field}_ods` as keyof IVisusFields]}
                        value_os={props.customControlData[`${visusfield.field}_os` as keyof IVisusFields]}
                    />
                );
            })}
        </>
    );
}
